// eslint-disable-next-line complexity
export function getTranslationKeyForDay(day: number): string {
  switch (day) {
    case 0:
      return 'general.date.days.sundayShort';
    case 1:
      return 'general.date.days.mondayShort';
    case 2:
      return 'general.date.days.tuesdayShort';
    case 3:
      return 'general.date.days.wednesdayShort';
    case 4:
      return 'general.date.days.thursdayShort';
    case 5:
      return 'general.date.days.fridayShort';
    case 6:
      return 'general.date.days.saturdayShort';
    default:
      return 'general.date.days.sundayShort';
  }
}
